import React, { useEffect, useContext, useRef } from "react";
import { Context } from "./Reducers/Store";
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";

import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard.js";
import UsuarioList from "./pages/Usuarios/UsuarioList.js";
import UsuarioForm from "./pages/Usuarios/UsuarioForm.js";

import GrupoList from "./pages/Grupos/GrupoList.js";
import GrupoForm from "./pages/Grupos/GrupoForm.js";

import ControleUsuarioList from "./pages/ControleUsuarios/ControleUsuarioList.js";
import ControleUsuarioForm from "./pages/ControleUsuarios/ControleUsuarioForm.js";

import ExcecaoList from "./pages/Excecoes/ExcecaoList.js";
import ExcecaoForm from "./pages/Excecoes/ExcecaoForm.js";

import LayoutEmpty from "./pages/Layouts/LayoutEmpty.js";
import SmartRedirect from "./components/SmartRedirect/index.js";
import RequireAuth from "./RequireAuth.js";
import LayoutDashboard from "./pages/Layouts/LayoutDashboard.js";
import PrimeiroAcesso from "./pages/PrimeiroAcesso/PrimeiroAcesso.js";
import EsqueciSenha from "./pages/EsqueciSenha/EsqueciSenha.js";
import ResetSenha from "./pages/ResetSenha/ResetSenha.js";
import AlterarSenha from "./pages/AlterarSenha/AlterarSenha.js";

import BackupList from "./pages/Backup/BackupList.js";
import QueriesLentasList from "./pages/QueriesLentas/QueriesLentasList.js";
import DatabaseList from "./pages/Databases/DatabaseList.js";

export default function App() {
  const firstLoad = useRef(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [state, dispatch] = useContext(Context);

  useEffect(() => {
    const jwt = localStorage.getItem("jwt");
    const refreshToken = localStorage.getItem("refreshToken");
    if (jwt)
      dispatch([{ type: "SET_LOGGED", payload: { success: true, data: { accessToken: jwt, refreshToken: refreshToken } } }, { type: "SET_READY", payload: true }]);
    else
      dispatch([{ type: "SET_LOGGED", payload: null }, { type: "SET_USER_PREFERENCES", payload: null }, { type: "SET_READY", payload: true }]);
  }, []);

  useEffect(() => {
    if (state.isLogged) {
      if (firstLoad.current) {
        firstLoad.current = false;
        if (location?.pathname === "/login") {
          navigate("/", { state: { from: { pathname: "/dashboard" } } });
        }
      }
    }
  }, [state.isLogged]);

  return state.ready ? 
    <Routes>
      <Route element={<LayoutEmpty />}>
        <Route path="/login" element={<Login />} />
        <Route path="/primeiro-acesso/:token" element={<PrimeiroAcesso />} />
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/reset-senha/:token" element={<ResetSenha />} />
      </Route>
      
      <Route element={<RequireAuth><LayoutDashboard /></RequireAuth>}>
        <Route path="/" element={<SmartRedirect />} />

        <Route path="/dashboard" element={
          <RequireAuth permissao="dashboard.visualizar"><Dashboard /></RequireAuth>
        } />
        
        <Route path="/usuarios" element={
          <RequireAuth permissao="usuarios.visualizar"><UsuarioList /></RequireAuth>
        } />
        <Route path="/usuarios/novo" element={
          <RequireAuth permissao="usuarios.criar"><UsuarioForm /></RequireAuth>
        } />
        <Route path="/usuarios/:id" element={
          <RequireAuth permissao="usuarios.editar"><UsuarioForm /></RequireAuth>
        } />
        
        <Route path="/alterar-senha" element={
          <RequireAuth permissao="meuperfil.alterarsenha"><AlterarSenha /></RequireAuth>
        } />

        <Route path="/grupos" element={
          <RequireAuth permissao="grupos.visualizar"><GrupoList /></RequireAuth>
        } />
        <Route path="/grupos/novo" element={
          <RequireAuth permissao="grupos.criar"><GrupoForm /></RequireAuth>
        } />
        <Route path="/grupos/:id" element={
          <RequireAuth permissao="grupos.editar"><GrupoForm /></RequireAuth>
        } />

        <Route path="/controle-usuarios" element={
          <RequireAuth permissao="acessosbd.visualizar"><ControleUsuarioList /></RequireAuth>
        } />
        <Route path="/controle-usuarios/novo" element={
          <RequireAuth permissao="acessosbd.criar"><ControleUsuarioForm /></RequireAuth>
        } />
        <Route path="/controle-usuarios/:id" element={
          <RequireAuth permissao="acessosbd.editar"><ControleUsuarioForm /></RequireAuth>
        } />

        <Route path="/excecoes" element={
          <RequireAuth permissao="excecoes.visualizar"><ExcecaoList /></RequireAuth>
        } />

        <Route path="/excecoes/novo" element={
          <RequireAuth permissao="excecoes.criar"><ExcecaoForm /></RequireAuth>
        } />

        <Route path="/backups" element={
          <RequireAuth permissao="backups.visualizar"><BackupList /></RequireAuth>
        } />

        <Route path="/monitoramento/queries-lentas" element={
          <RequireAuth permissao="monitoramento.visualizar"><QueriesLentasList /></RequireAuth>
        } />

        <Route path="/databases" element={
          <RequireAuth permissao="bancos.visualizar"><DatabaseList /></RequireAuth>
        } />
      </Route>

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes> : null;
}